<script lang="ts">
  import { type ImageType } from "@briefmarken_katalog/types";
  import { t } from "$lib/i18n";

  export let picture: ImageType;
  export let onOpenFullImage: ()=>void;

  function handleClick(this: HTMLElement) {
    onOpenFullImage();
  }
</script>

<style>
  .image {
    width: 5vw;
    height: auto;
    object-fit: contain;
    display: block;
    max-height: 100%;

    cursor: pointer;
    display: inline-block;
  }

  /* On narrow screens 5vw is near-invisible; a fixed height also keeps row heights uniform */
  @media (max-width: 639px) {
    .image {
      width: auto;
      height: 56px;
      max-width: 40vw;
    }
  }
</style>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="card-3d card-3d-anim" style="width: fit-content;" on:click={handleClick} on:keydown={()=>{  }}>
    <img
    class="image"
    src={picture.thumbnail ?? picture.base64}
    alt={$t('alt.stamp')}
    />    
</div>